<template>
    <div class="list">
         <div class="left">公告</div>
         <div class="right">
             <div class="wrapper" :style="{top}" :class="{'ulactive':currentindex>0}">
                 <div class="item" v-for="(item,index) in bannerList" :key="index">
                     <div class="item_text">
                          <p class="countryName">{{item.countyName}}</p>
                          <p class="item_text_content">{{item.memo}}</p>
                     </div>
                     <p class="abount_time" v-if='item.noticeTime'>{{item.noticeTime|filtTime}}</p>
                 </div>
             </div>
         </div>
    </div>
</template>
<script>
    export default {
        props: ['bannerList'],
        data () {
            return {
                bannerList1: [
                    { 'value': '1' },
                    { 'value': '1' },
                    { 'value': '1' },
                    { 'value': '1' },
                    { 'value': '1' },
                    { 'value': '1' }
                ],
                currentindex: 0,
                timed: null
            }
        },
        computed: {
            top () {
                return -this.currentindex * 1.44 + 'rem';
            }
        },
        created () {
            this.changeAnimate();
        },
        methods: {
            changeAnimate () {
                clearInterval(this.timed);
                this.timed = setInterval(() => {
                    if (this.currentindex < this.bannerList.length - 1) {
                        this.currentindex++;
                    } else {
                        this.currentindex = 0;
                    }
                }, 3000);
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    }
</script>
<style lang="less" scoped>
.list{
    width:100%;
    height:78px;
    padding: 12px 0;
    display: flex;
    display: -webkit-flex;
    // justify-content: space-between;
    border:1px solid #FBFBFB;
    align-items: center;
    background-color: #fff;
    .left{
        width:56px;
        height:78px;
        line-height: 78px;
        text-align: center;
        border-right:1px solid #FBFBFB;
        font-size:13px;
        color:#333333;
    }
    .right{
        width:100%;
        height:54px;
        position: relative;
        overflow: hidden;
        .wrapper{
            width:100%;
            position: absolute;
            left:0;
            top:0;
            .item{
                width:100%;
                padding:0 12px;
                box-sizing: border-box;
                height:54px;
                display: flex;
                display: -webkit-flex;
                justify-content: space-between;
                // border:1px solid #FBFBFB;
                align-items: center;
                .item_text{
                    p:nth-child(1){
                    font-size:10px;
                    color:#999999;
                    border: 1px solid #ccc;
                    display: inline-block;
                    padding: 2px 4px;
                    }
                    .item_text_content{
                        font-size: 12px;
                        margin-top: 2px;
                        line-height: 16px;
                        color:#999999;
                    }
                    // p:nth-child(2){
                    //     font-size:13px;
                    //     color:#666666;
                    //     margin-top:6px;
                    // }
                }
                .abount_time{
                    font-size:12px;
                    color:#999;
                    line-height: 16px;
                    text-align: center;
                }

            }
        }
        .ulactive{
            transition: all 0.5s ease-in-out;
        }
    }
}
</style>
